import { useEffect, useState, type FormEventHandler } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row, Button, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../redux/authActions";
import { api } from "../../utils/api";
import { getLoginCustomErrorMessage } from "../../utils/errorMessages";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(""); // Initialize error as an empty string
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    sessionStorage.clear();
  }, []);

  const proceedLogin = () => {
    api
      .login({ email, password })
      .then(async (data) => {
        window.sessionStorage.setItem("token", JSON.stringify(data.data));
        const user = data.data.user;
        const token = data.data.token;
        dispatch(loginSuccess({ token, id: user.id, userType: user.userType }));
        navigate(user.userType === "Admin" ? "/admin-home" : "/user-home");
      })
      .catch((error) => {
        console.log("Error occurred during login:", error);
        const customErrorMessage = getLoginCustomErrorMessage(error);
        setError(customErrorMessage); // Set the custom error message in state
      });
  };

  const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    setError(""); // Reset error state before login
    proceedLogin();
  };

  return (
    <Container className="d-flex flex-grow-1 flex-column justify-content-center">
      <Row className="justify-content-center mb-6">
        <Col xs={12} md={6} lg={4} className="my-md-3 my-1">
          <div>
            <h2 className="text-center fs-4">
              DedroneDefender{" "}
              <span style={{ whiteSpace: "nowrap" }}>Download Portal</span>
            </h2>
            <div className="d-flex justify-content-center mb-3">
              <img
                src="/dedrone-logo.svg"
                alt="DedroneDefender Logo"
                style={{
                  colorScheme: "light", // Override dark mode style for current white background
                }}
                width={64}
                height={64}
              />
            </div>
            <h1 className="text-center fs-3 mb-4">Login</h1>
            <Form
              className="login-form d-flex gap-3 flex-column"
              onSubmit={handleSubmit}
            >
              <Form.Group>
                <Form.Label htmlFor="username">
                  Email or username{" "}
                  <span title="This field is required">*</span>
                </Form.Label>
                <Form.Control
                  value={email}
                  type="text"
                  size="lg"
                  placeholder="Enter your email or username"
                  id="username"
                  name="username"
                  autoComplete="username webauthn"
                  onChange={(e) => setEmail(e.target.value.toLowerCase())}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label htmlFor="password">
                  Password <span title="This field is required">*</span>
                </Form.Label>
                <Form.Control
                  value={password}
                  type="password"
                  size="lg"
                  placeholder="Enter your password"
                  id="password"
                  name="password"
                  autoComplete="current-password webauthn"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
              {error && (
                <div className="text-danger" role="alert">
                  {error}
                </div>
              )}{" "}
              {/* Display error message if error exists */}
              <Button
                variant="dark"
                type="submit"
                className="mt-3 px-5 align-self-start"
              >
                Login
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
      {/* Spacer for larger screens to make up for vertical centering with navbar present */}
      <Row className="d-none d-lg-block py-4" />
    </Container>
  );
};
export default AdminLogin;
